import apiOffice from "../axios/apiOffice";

class AreaService {
  static async getAll() {
    try {
      const response = await apiOffice.get(`/areas/`);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting person:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default AreaService; 